
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnDestroy, inject } from "@angular/core";

import { Subject } from "rxjs";
import { Broadcaster } from "../../../common/providers/broadcaster.service";
import { CommonUtil } from "../../../common/utils/common.utils";
import { takeUntil } from "rxjs/operators";
import { VNCButtonComponent } from "@uxf/vnc-library";
import { TranslatePipe } from "@ngx-translate/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "vp-install-app",
    templateUrl: "./install-app.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [VNCButtonComponent, TranslatePipe]
})
export class InstallAppDialogComponent implements AfterViewInit, OnDestroy {
  private broadcaster = inject(Broadcaster);
  private changeDetectionRef = inject(ChangeDetectorRef);
  private dialog = inject<MatDialogRef<InstallAppDialogComponent>>(MatDialogRef);
  private appData = inject<any>(MAT_DIALOG_DATA);

  private viewInitialized = false;

  private isAlive$ = new Subject<boolean>();
  appName: string;
  appLink: string;
  constructor() {
    this.broadcaster.on<any>("closeAllMdlDialogs")
      .pipe(takeUntil(this.isAlive$))
      .subscribe(res => {
        this.dialog.close();
      });
    this.broadcaster.on<any>("closeDialog")
      .pipe(takeUntil(this.isAlive$))
      .subscribe(res => {
        this.dialog.close();
      });

    if (!!this.appData) {
      this.appName = this.appData.appName;
    }
  }

  ngAfterViewInit() {
    if (!this.viewInitialized) {
      this.viewInitialized = true;

      this.onPushBugHack();
    }
  }

  ngOnDestroy() {
    this.isAlive$.next(false);
    this.isAlive$.complete();
  }

  installApp() {
    this.dialog.close();
    window.open("itms-apps://itunes.apple.com/app/id1165103905", "_system");
  }

  private onPushBugHack() {
    setTimeout(() => {
      try {
        this.changeDetectionRef.detectChanges();
      } catch (e) {
        console.log("[vp-install-app onPushBugHack()", e);
      }
    }, 100);
  }

  @HostListener("document:keydown.esc")
  cancel(): void {
    this.dialog.close();
  }

}
